export default "__VITE_ASSET__4a1a6453__"